import { createAsyncThunk } from "@reduxjs/toolkit";
import Sessions from "utils/Sessions";
import ApiService from "../ApiService/ApiService";

export const getSafetyAlerts = createAsyncThunk("safety-alerts/list", async (params) => {
  const res = await ApiService.get(`global-safety-alerts?${params}`, {
    headers: { Authorization: `Bearer ${Sessions.userToken}` },
  })
    .then((r) => r)
    .catch((error) => error.response);
  return res;
});

export const createSafetyAlert = createAsyncThunk("safety-alerts/create", async (body) => {
  const res = await ApiService.post(
    `global-safety-alerts`,
    { ...body },
    {
      headers: { Authorization: `Bearer ${Sessions.userToken}` },
    }
  )
    .then((r) => r)
    .catch((err) => err.response);
  return res;
});

export const updateSafetyAlert = createAsyncThunk("safety-alerts/update", async (body) => {
  const res = await ApiService.patch(
    `global-safety-alerts/${body.id}`,
    { ...body.body },
    {
      headers: { Authorization: `Bearer ${Sessions.userToken}` },
    }
  )
    .then((r) => r)
    .catch((err) => err.response);
  return res;
});

export const deleteSafetyAlert = createAsyncThunk("safety-alerts/delete", async (id) => {
  const res = await ApiService.delete(`global-safety-alerts/${id}`, {
    headers: { Authorization: `Bearer ${Sessions.userToken}` },
  })
    .then((r) => r)
    .catch((err) => err.response);
  return res;
});

export const getPendingSafetyAlerts = createAsyncThunk("safety-alerts/pending", async () => {
  const res = await ApiService.get(`global-safety-alerts/pending`, {
    headers: { Authorization: `Bearer ${Sessions.userToken}` },
  })
    .then((r) => r)
    .catch((error) => error.response);
  return res;
});

export default getSafetyAlerts;
